import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import { MenuItem } from '../components/Menu';
import postIcon from '../icons/non-prefilled/16x16/post.svg';
import { createPostPath } from '../utils/url/postPath';

interface CreatePostMenuItemProps {
  children?: React.ReactNode;
  topicId?: string | null;
}

const CreatePostMenuItem = ({
  children = 'Create post',
  topicId = null,
}: CreatePostMenuItemProps) => {
  const isLocked = useAppSelector(
    (state) => state.session.organization.isLocked ?? false,
  );

  return (
    <MenuItem
      disabled={isLocked}
      icon={postIcon}
      to={createPostPath({ topicId: topicId ?? undefined })}
    >
      {children}
    </MenuItem>
  );
};

export default CreatePostMenuItem;
